import React from "react";
import {
  Filter,
  Create,
  TextInput,
  LongTextInput,
  SaveButton,
  List,
  Datagrid,
  TextField,
  Pagination,
  Button,
  Link,
  Toolbar,
  Edit,
  SimpleForm,
  EditButton
} from "react-admin";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";

const ListPagination = props => (
  <Pagination rowsPerPageOptions={[10, 25, 50, 100]} {...props} />
);

const MaintenanceItemTypeTitle = object => (
  <span>
    {" Edit Maintenance Item Type entry "} {object.record.description}
  </span>
);

const MaintenanceItemTypeCreateTitle = record => (
  <span>Create Maintenance Item Type entry</span>
);

const MaintenanceItemTypesListFilter = props => (
  <Filter {...props}>
    <TextInput label="Description" source="q" alwaysOn />
  </Filter>
);

export const MaintenanceItemTypeList = props => (
  <List
    {...props}
    title="Maintenance Item Types"
    resource="maintenance_item_types"
    bulkActionButtons={false}
    pagination={<ListPagination />}
    filters={<MaintenanceItemTypesListFilter />}
  >
    <Datagrid>
      <TextField label="Id" source="id" />
      <TextField label="Description" source="description" />
      <EditButton />
      {/* <DeleteButton/> */}
    </Datagrid>
  </List>
);

const MaintenanceItemTypesToolbar = props => (
  <Toolbar {...props}>
    <SaveButton redirect={`/maintenance_item_types`} />
    {/* <DeleteButton record={props.record} resource={props.resource} redirect={`/maintenance_item_types`} />  */}
    <Button
      component={Link}
      to={{
        pathname: `/maintenance_item_types`
      }}
      label="Back to maintenance item types"
    >
      <ArrowBackIcon />
    </Button>
  </Toolbar>
);

export const MaintenanceItemTypeEdit = props => (
  <Edit title={<MaintenanceItemTypeTitle />} {...props}>
    <SimpleForm toolbar={<MaintenanceItemTypesToolbar />}>
      <LongTextInput source="description" label="Description" />
    </SimpleForm>
  </Edit>
);

export const MaintenanceItemTypeCreate = props => (
  <Create title={<MaintenanceItemTypeCreateTitle />} {...props}>
    <SimpleForm toolbar={<MaintenanceItemTypesToolbar />}>
      <LongTextInput source="description" label="Description" />
    </SimpleForm>
  </Create>
);



// WEBPACK FOOTER //
// ./src/resources/maintenanceItemTypes.js